import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class MenuNewProductService extends BehaviorSubject<string[]> {
  constructor() {
    super(null);
  }
}
